import { type ShiftStateDependencies } from "@src/appV2/Shifts/Shift/ShiftState/types";

import { type ShiftTimekeepingDetails } from "../types";

export function mapShiftStateDependencies(shift: ShiftTimekeepingDetails): ShiftStateDependencies {
  const {
    _id,
    start,
    end,
    clockInOut,
    lunchInOut,
    facility,
    timecard,
    isInstantPay,
    deleted,
    verified,
    facilityId,
  } = shift;

  return {
    _id: _id ?? "",
    start: start ?? "",
    end: end ?? "",
    clockInOut,
    lunchInOut,
    facility: {
      id: facilityId ?? "",
      tmz: facility?.tmz ?? "",
    },
    timecard: {
      files: timecard?.files ?? [],
    },
    isInstantPay: isInstantPay ?? false,
    deleted: deleted ?? false,
    verified: verified ?? false,
  };
}
